import React from 'react';
import { Box } from '@mui/material';
import { ReportProblem } from '@mui/icons-material';

type Props = {
  children: React.ReactNode;
  testId?: string;
};

export const AgentHubWarningBanner = ({ children, testId }: Props): JSX.Element => (
  <Box
    data-testid={testId}
    sx={{
      display: 'flex',
      width: '100%',
      border: '1px solid',
      borderColor: 'warning.main',
      borderRadius: '8px',
      overflow: 'hidden',
      bgcolor: 'warning.light',
    }}
  >
    <Box
      sx={{
        width: 30,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'warning.main',
      }}
    >
      <ReportProblem sx={{ fontSize: 16, color: 'common.white' }} aria-hidden />
    </Box>

    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        px: '14px',
        py: '12px',
      }}
    >
      <Box
        sx={{
          color: 'warning.dark',
          fontFamily: 'Poppins, sans-serif',
          fontSize: 14,
          lineHeight: '18px',
        }}
      >
        {children}
      </Box>
    </Box>
  </Box>
);
